module.exports = __webpack_public_path__ + "media/images/landing/ar/save_time@2x-9fd07a86753519913001f1a73f134ea8.webp";